export const SET_LOCKED = 'mainToolBar/SET_LOCKED';
export const SET_OPEN = 'mainToolBar/SET_OPEN';
export const SET_ACTION_GROUP = 'mainToolBar/SET_ACTION_GROUP';
export const SET_SELECTED_TAB = 'mainToolBar/SET_SELECTED_TAB';
export const SET_OPEN_MODELS = 'mainToolBar/SET_OPEN_MODELS';
export const SET_SHOW_CLIPPING_PANES = 'mainToolBar/SET_SHOW_CLIPPING_PANES';
export const SET_WORKING_MESSAGE = 'mainToolBar/SET_WORKING_MESSAGE';
export const SET_ALIGNEMENT = 'mainToolBar/SET_ALIGNEMENT';
export const SET_VIEWS = 'mainToolBar/SET_VIEWS';
export const INSPECT_ALL_IMAGES = 'Inspect all images';
export const SET_CENTER_POSITION = 'mainToolBar/SET_CENTER_POSITION';
export const SHOW_ONLY_SELECTED = 'Show only selected';
export const DELETE_ALL_MEASUREMENTS = 'Delete all measurements';
export const COMPARE = 'Compare';
export const INSPECT_DIRECT_IMAGES = 'Inspect direct images';
export const MEASURE_POLYGONE = 'Measure polygone';
export const MEASURE_POLYLINE = 'Measure polyline';
export const MEASURE_LINE = 'Measure line';
export const ADD_ENTITIES = 'Add entities';
export const MODELS = 'Models';
export const IMAGES = 'Images';
export const VIEWS = 'Views';
export const CALIBRATION = 'Calibration';
export const SETTINGS = 'Settings';
export const DEFECTS = 'defects';
export const MMS = 'mms';
export const GENERAL = 'general';
export const METER = 'meter';
export const FEET = 'feet';

